import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Optional, SkipSelf } from '@angular/core';
import { createServiceApi, serviceTypes, combineEffectsWithProviders } from '@essent/common';
import * as i1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';

const apiVersion$1 = '1';
const getEstimatedConsumptionByAddressApi = createServiceApi('[EstimateConsumptionState] Get estimated consumption by address', 'get', serviceTypes(), {
    getUrl: `/metering/address/expectedconsumption/v${apiVersion$1}`,
    version: apiVersion$1,
    getParams: payload => payload
});

const apiVersion = '1';
const getEstimatedConsumptionByHouseTypeApi = createServiceApi('[EstimateConsumptionState] Get estimated consumption by house type', 'get', serviceTypes(), {
    getUrl: `/metering/housetype/expectedconsumption/v${apiVersion}`,
    version: apiVersion,
    getParams: payload => payload
});

const API = new InjectionToken('api-estimate-consumption');

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getEstimatedConsumptionByAddressApi, getEstimatedConsumptionByHouseTypeApi);
class EstimateConsumptionCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('EstimateConsumptionCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: EstimateConsumptionCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: EstimateConsumptionCoreModule, deps: [{ token: EstimateConsumptionCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: EstimateConsumptionCoreModule, imports: [i1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: EstimateConsumptionCoreModule, providers: PROVIDERS, imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: EstimateConsumptionCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: PROVIDERS
                }]
        }], ctorParameters: () => [{ type: EstimateConsumptionCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

var HouseType;
(function (HouseType) {
    HouseType["APARTMENT"] = "appartement";
    HouseType["TERRACED_HOUSE"] = "rijtje";
    HouseType["CORNER"] = "hoek";
    HouseType["SEMIDETACHED"] = "2onder1kap";
    HouseType["DETACHED"] = "vrijstaand";
})(HouseType || (HouseType = {}));

const { getEstimatedConsumptionByAddress, getEstimatedConsumptionByAddressSuccess, getEstimatedConsumptionByAddressError, getEstimatedConsumptionByAddressClear, getEstimatedConsumptionByAddressActions } = getEstimatedConsumptionByAddressApi;

const { getEstimatedConsumptionByHouseType, getEstimatedConsumptionByHouseTypeSuccess, getEstimatedConsumptionByHouseTypeError, getEstimatedConsumptionByHouseTypeClear, getEstimatedConsumptionByHouseTypeActions } = getEstimatedConsumptionByHouseTypeApi;

/**
 * Generated bundle index. Do not edit.
 */

export { API, EstimateConsumptionCoreModule, HouseType, getEstimatedConsumptionByAddress, getEstimatedConsumptionByAddressActions, getEstimatedConsumptionByAddressClear, getEstimatedConsumptionByAddressError, getEstimatedConsumptionByAddressSuccess, getEstimatedConsumptionByHouseType, getEstimatedConsumptionByHouseTypeActions, getEstimatedConsumptionByHouseTypeClear, getEstimatedConsumptionByHouseTypeError, getEstimatedConsumptionByHouseTypeSuccess };
